import { ApplicationError } from "@/error/ApplicationError";
import type { UnknownRecord } from "@/utils/type";

export class TimeoutError extends ApplicationError {
  constructor(contexts: { request: UnknownRecord; response: UnknownRecord }) {
    super("TimeoutError", "", contexts);
  }
}
